
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import React, { useEffect } from 'react';
import '../styles/globals.scss';
import Layout, { type HeaderFooterType } from './layout/layout';
import { type AppProps } from 'next/app';
import { initializeAnalytics } from '../utils/analytics/analytics-utils';
import { initializeGTM } from '@/utils/analytics/google-tag-manager';
import Script from 'next/script';
import { IViewDefinition } from '@/utils/view-definition.interface';

export interface PreRenderProps {
  headerFooter?: HeaderFooterType | null;
  viewDefinitionResults: {
    viewDefinition: IViewDefinition;
    currentUrlBase: string;
  } | null;
  themeTokens: object | null;
  cartData: object | null;
}

function MyApp({ Component, pageProps }: AppProps<PreRenderProps>) {
  const { headerFooter, cartData } = pageProps;

  const hasError =
    pageProps.headerFooter === null || pageProps.themeTokens === null || pageProps.viewDefinitionResults === null;

  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <Layout headerFooterData={headerFooter} cartData={cartData} hasError={hasError}>
      <Script
        src="https://www.googletagmanager.com/gtm.js?id=GTM-TCJKP3F"
        strategy="lazyOnload"
        defer
        onLoad={() => {
          initializeGTM();
        }}
      />
      <Script src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" async />
      <Component {...pageProps} />
    </Layout>
  );
}

export default MyApp;
